import { WebSocket } from 'ws';

export class Participant {
    constructor(id:string, username:string, avatar:string | null, rd:boolean, rm:string, rg:string, mp:string, md:string, ij:string, ws?:WebSocket) {
        this.id = id;
        this.username=username;
        this.avatar=avatar;
        if(ws) this.ws = ws;
        this.isready = rd;    
        this.room = rm;
        this.region = rg;
        this.map = mp;
        this.mode = md;
        this.isJoining = ij;
    }
    public id: string;
    public username: string;
    public avatar: string | null;
    public ws: WebSocket;
    public isready: boolean;
    //In-game values
    public room: string;
    public region: string;
    public map: string;
    public mode: string;
    public isJoining: string;
    public timestamp:number;
}

export interface ParticipantInfo {
    id: string;
    username: string;
    avatar: string | null;
    isready: boolean;
    //In-game values
    room: string;
    region: string;
    map: string;
    mode: string;
    isJoining: string;
}
  
  
export class ActivityInstance {
    constructor(instanceId:string, password?:string, shareLink?:string) {
        this.instanceId = instanceId;
        this.creationTimestamp = Date.now();         
        this.users = [];
        if(password) this.password = password;
        if(shareLink) this.shareLink = shareLink;
    }
    public addParticipant(participant:Participant):void {
        var userIndex = this.users.findIndex(x=>x.id == participant.id);
        if(userIndex<0) {
            this.users.push(participant);
        }else{
            this.users[userIndex] = participant;
        }
    }
    public getLeader():Participant {
        return this.leader;
    }
    public setLeader(leaderId:string):Participant|null {
        var leader = this.users.find(x=>x.id==leaderId);
        if(leader!=null) {
            this.leader = leader;
            return leader
        }
        return null;
    }

    public instanceId: string;
    public leaderid: string;
    public leader: Participant;
    public users: Participant[] = [];
    
    public shareLink:string ="";
    public password: string = ""; // Add this field
    
    public creationTimestamp:number = 0;
    public lastUpdate:number = 0;
    
    public isprivate:boolean = false;
}
  
export interface TokenData {
    token_type: string;
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
}
  
export interface UserData {
    id: string;
    username: string;
    avatar: string | null;
    discriminator: string;
    public_flags: number;
    flags: number;
    banner: string | null;
    accent_color: number | null;
    global_name: string | null;
    avatar_decoration_data: any | null;
    banner_color: string | null;
    clan: string | null;
    mfa_enabled: boolean;
    locale: string;
    premium_type: number;
    isready: boolean;
    //In-game values
    room: string;
    region: string;
    map: string;
    mode: string;
    isJoining: string;
}
  
